import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import RosaryIcon from "./RosaryIcon";
import "./Help.scss";

function Help() {
  const { t } = useTranslation();

  const steps = [
    {
      icon: "🔍",
      title: t("help_enhanced.step_1_title"),
      description: t("help_enhanced.step_1_desc"),
    },
    {
      icon: "✅",
      title: t("help_enhanced.step_2_title"),
      description: t("help_enhanced.step_2_desc"),
    },
    {
      icon: "🙏",
      title: t("help_enhanced.step_3_title"),
      description: t("help_enhanced.step_3_desc"),
    },
    {
      icon: "🗑️",
      title: t("help_enhanced.step_4_title"),
      description: t("help_enhanced.step_4_desc"),
    },
  ];

  const features = [
    {
      icon: "🔒",
      title: t("help_enhanced.privacy_title"),
      description: t("help_enhanced.privacy_desc"),
    },
    {
      icon: "💾",
      title: t("help_enhanced.storage_title"),
      description: t("help_enhanced.storage_desc"),
    },
    {
      icon: "🌐",
      title: t("help_enhanced.offline_title"),
      description: t("help_enhanced.offline_desc"),
    },
  ];

  const additionalFeatures = [
    {
      icon: "✝️",
      title: t("help_enhanced.saints_title"),
      description: t("help_enhanced.saints_desc"),
    },
    {
      icon: <RosaryIcon width={32} height={48} />,
      title: t("help_enhanced.rosary_title"),
      description: t("help_enhanced.rosary_desc"),
    },
    {
      icon: "❤️",
      title: t("help_enhanced.coronilla_title"),
      description: t("help_enhanced.coronilla_desc"),
    },
    {
      icon: "🙏",
      title: t("help_enhanced.litany_title"),
      description: t("help_enhanced.litany_desc"),
    },
  ];

  return (
    <div className="help-page">
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            {/* Header */}
            <div className="text-center mb-5">
              <h1 className="help-title">{t("help_enhanced.title")}</h1>
              <p className="help-subtitle">{t("help_enhanced.subtitle")}</p>
            </div>

            {/* How to use */}
            <section className="mb-5">
              <h2 className="section-title">{t("help_enhanced.how_to_use")}</h2>
              <div className="steps-grid">
                {steps.map((step, index) => (
                  <Card key={index} className="step-card">
                    <Card.Body className="text-center">
                      <div className="step-icon">{step.icon}</div>
                      <h3 className="step-title">{step.title}</h3>
                      <p className="step-desc">{step.description}</p>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </section>

            {/* Features */}
            <section className="mb-5">
              <h2 className="section-title">{t("help_enhanced.features")}</h2>
              <div className="features-grid">
                {features.map((feature, index) => (
                  <Card key={index} className="feature-card">
                    <Card.Body>
                      <div className="feature-icon">{feature.icon}</div>
                      <h3 className="feature-title">{feature.title}</h3>
                      <p className="feature-desc">{feature.description}</p>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </section>

            {/* Additional Features */}
            <section className="mb-5">
              <h2 className="section-title">{t("help_enhanced.additional_features")}</h2>
              <div className="features-grid">
                {additionalFeatures.map((feature, index) => (
                  <Card key={index} className="feature-card">
                    <Card.Body>
                      <div className="feature-icon">{feature.icon}</div>
                      <h3 className="feature-title">{feature.title}</h3>
                      <p className="feature-desc">{feature.description}</p>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </section>

            {/* Privacy notice */}
            <Card className="privacy-card">
              <Card.Body className="text-center">
                <div className="privacy-icon">⛪</div>
                <h3>{t("help_enhanced.privacy_notice_title")}</h3>
                <p className="mb-0">{t("help_enhanced.privacy_notice_desc")}</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Help;
